export const cookieKeyUser = 'retail_auth';
export const cookieKeyLink = 'redirect_link';
export const cookieKeyErrmessage = 'cms_errors_messages';
export const cookieKeyNotion = 'cms_notion';
export const cookieKeyAgencyIds = 'agency_ids';
